import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import Dialog from "@/components/billing/Dialog";

const OPTIONS = [
  { value: "yes", label: "Sí, ofrecer reparación" },
  { value: "skip", label: "No ofrecerlo" },
  { value: "not_interested", label: "No interesado" },
];

/** Iter 169 — Primer modal: incidencias negativas del Checklist → decisión por incidencia. */
export default function ChecklistIncidentsModal({ repairId, incidents, onClose, onOffer }) {
  const [choice, setChoice] = useState(() => Object.fromEntries(incidents.map((i) => [i.key, "yes"])));
  const [saving, setSaving] = useState(false);

  const confirm = async () => {
    setSaving(true);
    try {
      await api.post(`/repairs/${repairId}/checklist/decisions`, { decisions: choice });
      const yes = incidents.filter((i) => choice[i.key] === "yes");
      if (yes.length) onOffer(yes);
      else {
        toast.success("Decisión registrada. No se ha enviado nada al cliente.");
        onClose();
      }
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog onClose={onClose} title="Incidencias detectadas en el Checklist">
      <div data-testid="checklist-incidents-modal" className="space-y-4">
        <p className="text-sm text-[#525252]">
          Se {incidents.length === 1 ? "ha detectado una incidencia" : `han detectado ${incidents.length} incidencias`}. ¿Quieres ofrecer una reparación al cliente? No se enviará nada automáticamente.
        </p>
        {incidents.map((inc) => (
          <div key={inc.key} className="border border-[#E5E5E0] p-3" data-testid={`incident-${inc.key}`}>
            <div className="flex items-center gap-2 font-semibold text-sm">
              <AlertTriangle size={14} className="text-[#B4381F]" /> {inc.label}
            </div>
            <div className="mt-2 flex flex-wrap gap-2">
              {OPTIONS.map((o) => (
                <button
                  key={o.value}
                  type="button"
                  onClick={() => setChoice((c) => ({ ...c, [inc.key]: o.value }))}
                  data-testid={`incident-${inc.key}-${o.value}`}
                  className={`px-3 py-1.5 text-xs font-mono uppercase tracking-wider border transition-colors ${
                    choice[inc.key] === o.value ? "bg-[#111110] text-white border-[#111110]" : "bg-white border-[#E5E5E0] hover:border-[#111110]"
                  }`}
                >
                  {o.label}
                </button>
              ))}
            </div>
          </div>
        ))}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} className="px-4 py-2 text-xs uppercase tracking-wider border border-[#E5E5E0]" data-testid="incidents-cancel">
            Más tarde
          </button>
          <button type="button" onClick={confirm} disabled={saving} data-testid="incidents-continue"
            className="px-4 py-2 text-xs uppercase tracking-wider bg-[#6E8B3D] text-white font-semibold disabled:bg-[#A8A8A0]">
            {saving ? "Guardando…" : "Continuar"}
          </button>
        </div>
      </div>
    </Dialog>
  );
}
